import React, { useEffect } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from './components/Routes';
import { DataProvider } from "./context/DataContext.js";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import config from "./utilities/config";


const theme = createTheme({
  palette: {
    primary: { main: config.colors.primary },
    secondary: { main: config.colors.secondary },
  },
});


function App() {
  useEffect(() => {
    const faviconLink = document.querySelector("link[rel='icon']");
    if (faviconLink) {
      faviconLink.href = process.env.REACT_APP_FAVICON; // Set favicon
    }
    document.title = process.env.REACT_APP_NAME || "Survey Application"; // set title
  }, []);

  // return (
  //   <div>
  //     <header>
  //       <img src={process.env.REACT_APP_LOGO} alt="Client Logo" />
  //     </header>
  //     <main>
  //       <h1>Welcome to the Client's App</h1>
  //     </main>
  //   </div>
  // );

  return (
    <Router>
      <DataProvider>
        <ThemeProvider theme={theme}>
          <div className="App">
            <main className="App-body">
              <AppRoutes />
            </main>
          </div>
        </ThemeProvider>
      </DataProvider>
    </Router>
  );
}

export default App;
